module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/library-assets/article/article.component.scss
// module id = ./src/app/library-assets/article/article.component.scss
// module chunks = main